import { render } from "./recommendList.vue?vue&type=template&id=e7a53bcc"
import script from "./recommendList.vue?vue&type=script&lang=js"
export * from "./recommendList.vue?vue&type=script&lang=js"

import "./recommendList.vue?vue&type=style&index=0&id=e7a53bcc&lang=less"

import exportComponent from "/root/.jenkins/workspace/embeddedJobWebProd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__